const DAYS = [
  {
    day: "DAY 01",
    label: "Theory & Anatomy",
    title: "Physiological Foundations",
    body: "Lymphatic maps, visceral bio-mechanics, contraindications, and client assessment protocols.",
    img: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxtYXNzYWdlJTIwY2xhc3MlMjB0aGVvcnl8ZW58MHx8fHwxNzkyMjQ2MjM2fDA&ixlib=rb-4.1.0&q=85",
    alt: "Anatomy theory teaching session",
    tag: "Theory Modules",
  },
  {
    day: "DAY 02",
    label: "Hands-On Practice",
    title: "Visceral Manual Release",
    body: "Live model work under Elisabete's supervision. Pressure modulation and visceral unlocking.",
    img: "https://images.pexels.com/photos/8313244/pexels-photo-8313244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Guided hands-on practice on the treatment couch",
    tag: "Clinical Practice",
  },
  {
    day: "DAY 03",
    label: "Assessment & CPD",
    title: "Mastery & Accreditation",
    body: "Full sequence execution, timing calibration, practical exam, and CPD certificate award.",
    img: "https://images.pexels.com/photos/7713379/pexels-photo-7713379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Graduate receiving a CPD qualification certificate",
    tag: "CPD Qualification",
  },
];

export const Curriculum = () => (
  <section
    id="curriculum"
    data-testid="curriculum-section"
    className="py-24 bg-sand border-y border-cream px-6 md:px-12"
  >
    <div className="max-w-6xl mx-auto">
      <div className="max-w-xl mb-16">
        <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-forest font-semibold">
          Curriculum Breakdown
        </span>
        <h2 className="font-display text-3xl md:text-5xl tracking-tight text-ink mt-2">
          3 days of rigorous professional immersion.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {DAYS.map((d) => (
          <div
            key={d.day}
            data-testid={`curriculum-card-${d.day.slice(-2)}`}
            className="bg-linen p-8 rounded-2xl border border-cream flex flex-col justify-between hover:shadow-md transition-shadow"
          >
            <div>
              <div className="flex items-center justify-between mb-6">
                <span className="font-monolbl text-xs font-semibold px-3 py-1 rounded-full bg-forest/10 text-forest">
                  {d.day}
                </span>
                <span className="text-xs uppercase tracking-wider text-moss">{d.label}</span>
              </div>
              <h3 className="font-display text-2xl text-ink mb-3">{d.title}</h3>
              <p className="text-sm text-moss leading-relaxed mb-6">{d.body}</p>
            </div>
            <div className="h-40 rounded-lg overflow-hidden border border-cream relative">
              <img
                src={d.img}
                alt={d.alt}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/60 to-transparent">
                <span className="text-[10px] font-monolbl text-white/90 uppercase">{d.tag}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
